export const mapLocationToMenuKey = (pathname) => {
    return (pathname || window.location.pathname).replace(/^\//, "").split("/")[0];
  }